import React from 'react';
import '../styles/legal-page.css'; // Ensure the correct CSS is applied
import { Link } from 'react-router-dom';
import Footer from '../components/Footer'; // Import the Footer component

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="legal-page-container">
      {/* Clickable Dog Image - redirects to homepage */}
      <div className="centered-image-container">
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/curios-dog.jpeg`}
            alt="Curious Dog"
            className="circle-dog-image" 
          />
        </Link>
      </div>

      <div className="legal-content-container">
        <div className="content">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us. This policy outlines how we collect, use, and protect your personal information when you use Curios.dog.</p>

          <h2 className="legal-section-title">1. Data Collection</h2>
          <p>We collect the following information when you use our platform:</p>
          <ul>
            <li>Your username and email address when you join the waiting list.</li>
            <li>Any content you submit while using the platform.</li>
          </ul>

          <h2 className="legal-section-title">2. Use of Data</h2>
          <p>We use the data collected to:</p>
          <ul>
            <li>Manage your account and provide access to the platform.</li>
            <li>Send updates and notifications about Curios.dog.</li>
            <li>Improve the platform and user experience.</li>
          </ul>

          <h2 className="legal-section-title">3. Data Protection</h2>
          <p>
            We implement a variety of security measures to ensure the safety of your personal data. However, please note that no method of transmission over the internet is 100% secure.
          </p>

          <h2 className="legal-section-title">4. Sharing of Data</h2>
          <p>We do not share your personal data with third parties, except as required by law or to protect our rights.</p>

          <h2 className="legal-section-title">5. Cookies</h2>
          <p>
            We use cookies to enhance your experience on Curios.dog. Please refer to our <Link to="/cookie-policy">Cookie Policy</Link> for more details.
          </p>

          <h2 className="legal-section-title">6. Beta Experimental Phase</h2>
          <p>
            Curios.dog is currently in a beta experimental phase. During this period, please be aware that there is a possibility of data loss or service interruptions as we actively test and improve the platform. While we will do our best to maintain the integrity of your data, we cannot guarantee the full stability of the service during this phase. We recommend users regularly back up any important content.
          </p>

          <h2 className="legal-section-title">7. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page.</p>

          <h2 className="legal-section-title">8. Contact Information</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at support@curios.dog.</p>
        </div>

        <div className="join-waitlist-container">
          <button className="join-waitlist-btn" onClick={() => window.location.href = "/join"}>
            Join The Waiting List
          </button>
        </div>
      </div>

      <Footer /> {/* Add the Footer at the bottom of the page */}
    </div>
  );
};

export default PrivacyPolicy;
